module.exports = __webpack_public_path__ + "img/blue_131.84c66444.png";